import { FormInputWrapperProps } from "components/forms/part/FormInputWrapper/types";
import { Component } from "react";

export class FormInputWrapper extends Component<FormInputWrapperProps> {
	render():JSX.Element{
		const classes:string[] = ["input-wrapper"];

		if(this.props.contentAlign === "center"){
			classes.push("center");
		}

		return (
			<div className={classes.join(" ")}>
				{this.props.children}
			</div>
		);
	}
}
